export const enum Country {
  FRANCE = 'FR',
  MONACO = 'MC',
}
